var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":"rf-succeed"}}),_c('p',{domProps:{"textContent":_vm._s(_vm.word)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }